import apiClient from "./client";

export const getPublicSectors = async (language = "en") => {
  const attempts = [
    () => apiClient.get("/sectors", { params: { language } }),
    () => apiClient.get("/sectors/public", { params: { language } }),
  ];

  for (const run of attempts) {
    try {
      const response = await run();
      const data = response?.data;
      if (Array.isArray(data)) return data;
      if (Array.isArray(data?.items)) return data.items;
      if (Array.isArray(data?.data)) return data.data;
    } catch {
      // try next endpoint shape
    }
  }

  return [];
};

export const getPublicSectorBySlug = async (slug, language = "en") => {
  const key = String(slug || "").trim();
  if (!key) return null;

  const attempts = [
    () => apiClient.get(`/sectors/${encodeURIComponent(key)}`, { params: { language } }),
    () => apiClient.get("/sectors", { params: { slug: key, language } }),
  ];

  for (const run of attempts) {
    try {
      const response = await run();
      const data = response?.data;
      if (!data) continue;
      if (Array.isArray(data)) {
        const hit = data.find((it) => String(it?.slug || "").toLowerCase() === key.toLowerCase());
        if (hit) return hit;
        continue;
      }
      if (Array.isArray(data?.items)) {
        const hit = data.items.find((it) => String(it?.slug || "").toLowerCase() === key.toLowerCase());
        if (hit) return hit;
      }
      if (Array.isArray(data?.data)) {
        const hit = data.data.find((it) => String(it?.slug || "").toLowerCase() === key.toLowerCase());
        if (hit) return hit;
      }
      if (typeof data === "object") return data;
    } catch {
      // try next
    }
  }

  return null;
};
